import _classCallCheck from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.index-of.js";
import { __decorate } from "tslib";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator"; // import Components from "./index";

var FrontalePreview = function FrontalePreview() {
  return import("./FrontalePreview.vue");
};

var ColorGridIncisione = function ColorGridIncisione() {
  return import("./ColorGridIncisione.vue");
};

var ExtAstaDxPreview = function ExtAstaDxPreview() {
  return import("./ExtAstaDxPreview.vue");
};

var ExtAstaSxPreview = function ExtAstaSxPreview() {
  return import("./ExtAstaSxPreview.vue");
};

var IntAstaDxPreview = function IntAstaDxPreview() {
  return import("./IntAstaDxPreview.vue");
};

var IntAstaSxPreview = function IntAstaSxPreview() {
  return import("./IntAstaSxPreview.vue");
};

var ComponenteIncisione = /*#__PURE__*/function (_Vue) {
  _inherits(ComponenteIncisione, _Vue);

  var _super = _createSuper(ComponenteIncisione);

  function ComponenteIncisione() {
    var _this;

    _classCallCheck(this, ComponenteIncisione);

    _this = _super.apply(this, arguments);
    _this.itemActive = "";
    _this.isCartButtonDisabled = true;
    _this.namePosition = "ext";
    _this.activePreview = null;
    _this.colors = [{
      name: "nero",
      colorCode: "#212121",
      colorClass: "grey darken-4",
      checkColor: "white"
    }, {
      name: "bianco",
      colorCode: "#fafafa",
      colorClass: "grey lighten-5",
      checkColor: "grey"
    }, {
      name: "verde",
      colorCode: "#4caf50",
      colorClass: "green",
      checkColor: "white"
    }, {
      name: "blu",
      colorCode: "#2196f3",
      colorClass: "blu",
      checkColor: "white"
    }, {
      name: "giallo",
      colorCode: "#FFEB3B",
      colorClass: "yellow",
      checkColor: "grey"
    }, {
      name: "rosso",
      colorCode: "#f44336",
      colorClass: "red",
      checkColor: "white"
    }, {
      name: "rosa",
      colorCode: "#F8BBD0",
      colorClass: "pink",
      checkColor: "white"
    }, {
      name: "arancione",
      colorCode: "#FF9800",
      colorClass: "orange",
      checkColor: "white"
    }, {
      name: "viola",
      colorCode: "#AB47BC",
      colorClass: "purple",
      checkColor: "white"
    }, {
      name: "oro",
      colorCode: "#FFD700",
      colorClass: "gold",
      checkColor: "white"
    }, {
      name: "argento",
      colorCode: "#D3D3D3",
      colorClass: "silver",
      checkColor: "white"
    }, {
      name: "azzurro",
      colorCode: "#81D4FA",
      colorClass: "light blue",
      checkColor: "white"
    }, {
      name: "",
      colorCode: "#f4f4f4",
      colorClass: "no color",
      checkColor: ""
    }];
    return _this;
  }

  _createClass(ComponenteIncisione, [{
    key: "testo",
    get: function get() {
      if (this.itemActive == "Frontale") {
        return this.$store.state.configurator.frontali.name;
      } else if (this.itemActive == "AstaDx" && this.namePosition == "int") {
        return this.$store.state.configurator.aste.intDxName;
      } else if (this.itemActive == "AstaDx" && this.namePosition == "ext") {
        return this.$store.state.configurator.aste.extDxName;
      } else if (this.itemActive == "AstaSx" && this.namePosition == "int") {
        return this.$store.state.configurator.aste.intSxName;
      } else if (this.itemActive == "AstaSx" && this.namePosition == "ext") {
        return this.$store.state.configurator.aste.extSxName;
      }

      return "";
    },
    set: function set(c) {
      if (this.itemActive == "Frontale") {
        this.$store.commit("configurator/frontali/setName", c);
      } else if (this.itemActive == "AstaDx" && this.namePosition == "int") {
        this.$store.commit("configurator/aste/setIntDxName", c);
      } else if (this.itemActive == "AstaDx" && this.namePosition == "ext") {
        this.$store.commit("configurator/aste/setExtDxName", c);
      } else if (this.itemActive == "AstaSx" && this.namePosition == "int") {
        this.$store.commit("configurator/aste/setIntSxName", c);
      } else if (this.itemActive == "AstaSx" && this.namePosition == "ext") {
        this.$store.commit("configurator/aste/setExtSxName", c);
      }
    }
  }, {
    key: "colore",
    get: function get() {
      if (this.itemActive == "Frontale") {
        return this.$store.state.configurator.frontali.nameColor;
      } else if (this.itemActive == "AstaDx" && this.namePosition == "int") {
        return this.$store.state.configurator.aste.intDxNameColor;
      } else if (this.itemActive == "AstaDx" && this.namePosition == "ext") {
        return this.$store.state.configurator.aste.extDxNameColor;
      } else if (this.itemActive == "AstaSx" && this.namePosition == "int") {
        return this.$store.state.configurator.aste.intSxNameColor;
      } else if (this.itemActive == "AstaSx" && this.namePosition == "ext") {
        return this.$store.state.configurator.aste.extSxNameColor;
      }

      return "";
    },
    set: function set(c) {
      if (this.itemActive == "Frontale") {
        this.$store.commit("configurator/frontali/setNameColor", c);
      } else if (this.itemActive == "AstaDx" && this.namePosition == "int") {
        this.$store.commit("configurator/aste/setIntDxNameColor", c);
      } else if (this.itemActive == "AstaDx" && this.namePosition == "ext") {
        this.$store.commit("configurator/aste/setExtDxNameColor", c);
      } else if (this.itemActive == "AstaSx" && this.namePosition == "int") {
        this.$store.commit("configurator/aste/setIntSxNameColor", c);
      } else if (this.itemActive == "AstaSx" && this.namePosition == "ext") {
        this.$store.commit("configurator/aste/setExtSxNameColor", c);
      }
    }
  }, {
    key: "selectedColor",
    get: function get() {
      var _this2 = this;

      return this.colors.filter(function (c) {
        return c.name == _this2.colore;
      })[0];
    }
  }, {
    key: "previewComponent",
    value: function previewComponent(item, side) {
      if (!side) {
        return FrontalePreview;
      } else {
        if (side == "int" && item["int"] && this.namePosition == "int") {
          // return `Int${item.nome}Preview`;
          return item.nome.toUpperCase().indexOf("SX") > -1 ? IntAstaSxPreview : IntAstaDxPreview;
        } else if (side == "ext" && item.ext && this.namePosition == "ext") {
          return item.nome.toUpperCase().indexOf("DX") > -1 ? ExtAstaDxPreview : ExtAstaSxPreview; // return `Ext${item.nome}Preview`;
        }
      } // if (item.int == true) {
      // } else if (item.ext == true) {
      // } else if (item.ext == false && item.int == false) {
      //   return `${item.nome}Preview`;
      // }

    }
  }, {
    key: "setColore",
    value: function setColore(c) {
      this.colore = c.name;
    }
  }]);

  return ComponenteIncisione;
}(Vue);

__decorate([Prop()], ComponenteIncisione.prototype, "persComponent", void 0);

__decorate([Prop()], ComponenteIncisione.prototype, "itemActive", void 0);

ComponenteIncisione = __decorate([Component({
  components: {
    FrontalePreview: FrontalePreview,
    ColorGridIncisione: ColorGridIncisione,
    ExtAstaDxPreview: ExtAstaDxPreview,
    ExtAstaSxPreview: ExtAstaSxPreview,
    IntAstaDxPreview: IntAstaDxPreview,
    IntAstaSxPrevie: IntAstaSxPreview
  }
})], ComponenteIncisione);
export default ComponenteIncisione;